import find from 'lodash/find';
import filter from 'lodash/filter';
import { PROMO_TYPE } from './constants';

export const byId = (state, id) => find(state.settings.promoCodes, { id });
export const getActivePromo = state => state.engagement.campaign.promo;
export const enabled = state => filter(state.settings.promoCodes, { enabled: true });

export const isPercentagePromo = promoCode => promoCode.kind === PROMO_TYPE.percentage;
